import React from 'react';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'




class MainLayout extends React.Component {
    constructor(props) {
	super(props);
	props.isAuthenticatedRequest()
    }

    render() {
	 return this.props.children
    }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/utils/AuthneticationProvider/Authentication.jsx